import { apiCall } from './api';
import { SITES, SITE_DETAILS, SITE_STATUS, PUBLIC_SITES } from '../config/api';

// Get all sites
export const getSites = async (params = {}) => {
  try {
    console.log('🚀 getSites called with params:', params);
    console.log('🔗 Making API call to:', SITES);
    
    const response = await apiCall(SITES, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getSites:', response);
    return response.data;
  } catch (error) {
    console.error('❌ Error in getSites:', error);
    throw error;
  }
};

// Get only sites that have site_slug
export const getSitesWithSlug = async (params = {}) => {
  try {
    console.log('🚀 getSitesWithSlug called with params:', params);
    
    const response = await getSites(params);
    
    if (response && response.data) {
      const sites = Array.isArray(response.data) ? response.data : response.data.sites || [];
      const sitesWithSlug = sites.filter(s => s.site_slug && s.site_slug.trim() !== '');
      
      console.log('📋 Filtered sites with site_slug:', sitesWithSlug.length, 'out of', sites.length);
      
      return {
        ...response,
        data: sitesWithSlug
      };
    }
    
    return response;
  } catch (error) {
    console.error('❌ Error in getSitesWithSlug:', error);
    throw error;
  }
};

// Get site by ID
export const getSiteById = async (siteId) => {
  try {
    const endpoint = SITE_DETAILS.replace('{id}', siteId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching site:', error);
    throw error;
  }
};

// Get site by slug using public endpoint with params
export const getSiteBySlug = async (siteSlug) => {
  try {
    console.log('🚀 getSiteBySlug called with slug:', siteSlug);
    
    // Use public sites endpoint with site_slug parameter
    console.log('🔗 Making API call to:', PUBLIC_SITES, 'with params:', { site_slug: siteSlug });
    
    const response = await apiCall(PUBLIC_SITES, {
      method: 'GET',
      params: { site_slug: siteSlug }
    });
    console.log('📋 Response from getSiteBySlug:', response);
    if (response && response.data) {
      const sites = Array.isArray(response.data) ? response.data : response.data.sites || [];
      console.log('📋 Sites returned from API:', sites);
      console.log('🔍 Looking for site with slug:', siteSlug);
      
      // Filter sites by site_slug field
      const matchingSite = sites.find(site => site.site_slug === siteSlug);
      
      if (matchingSite) {
        console.log('✅ Site found by slug:', matchingSite);
        console.log('🖼️ Site logo path:', matchingSite.logo);
        console.log('🏷️ Site name:', matchingSite.site_name);
        return { data: matchingSite };
      } else {
        console.log('❌ No site found with site_slug:', siteSlug);
        console.log('📋 Available site_slugs:', sites.map(s => s.site_slug));
      }
    }
    
    console.log('❌ Site not found with slug:', siteSlug);
    return null;
  } catch (error) {
    console.error('Error fetching site by slug:', error);
    throw error;
  }
};

// Create new site
export const createSite = async (siteData) => {
  try {
    console.log('🚀 createSite called with data:', siteData);
    console.log('🔗 Making API call to:', SITES);
    console.log('📋 Logo URL in site data:', siteData.logo);
    
    // Send logo path as string to API
    const response = await apiCall(SITES, {
      method: 'POST',
      data: siteData
    });
    
    console.log('📡 API Response from createSite:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating site:', error);
    throw error;
  }
};

// Update site
export const updateSite = async (siteId, siteData) => {
  try {
    const endpoint = SITE_DETAILS.replace('{id}', siteId);
    console.log('🚀 updateSite called with ID:', siteId, 'and data:', siteData);
    console.log('🔗 Making API call to:', endpoint);
    console.log('📋 Logo URL in site data:', siteData.logo);
    
    // Send logo path as string to API
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: siteData
    });
    
    console.log('📡 API Response from updateSite:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating site:', error);
    throw error;
  }
};

// Delete site
export const deleteSite = async (siteId) => {
  try {
    const endpoint = SITE_DETAILS.replace('{id}', siteId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting site:', error);
    throw error;
  }
};

// Update site status
export const updateSiteStatus = async (siteId, status) => {
  try {
    const endpoint = SITE_STATUS.replace('{id}', siteId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating site status:', error);
    throw error;
  }
};
